"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNilOrHyphen = exports.roundNumber = exports.preciseRounding = exports.getDecimalPointCount = exports.formatToPercentWithoutDecimalPoints = exports.formatToPercentWithSuppliedDecimalPointCount = exports.convertToEuropeanFormat = exports.getDynamicMobileWidth = exports.renderPreciseValueOrEmDash = exports.renderValueOrEmDash = exports.getPercentageTicks = exports.getTicks = exports.getRoundedUpAmount = exports.getRoundedUpAmountBasedOnPlaceValue = exports.log10 = exports.getPlaceValue = exports.formatAmountWithCurrencySignAndCommasForLocale = exports.convertToNumberWithCommas = exports.convertToTwoDecimalFixedNumberWithNoRounding = exports.convertToNDecimalFixedNumber = exports.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100 = exports.formatToPercentWith2FixedDecimals = exports.formatToPercentWith1FixedDecimals = exports.convertToAmountWithPreciseRounding = exports.convertToAmount = exports.convertDecimalToMultiply100WithFixedDecimals = exports.convertDecimalToPercentWith2FixedDecimals = undefined;

var _ramda = require("ramda");

var _functional_utility = require("./functional_utility");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable */
var NumberUtility = {
  convertDecimalToPercentWith2FixedDecimals: function convertDecimalToPercentWith2FixedDecimals(amount) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
    var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    var rounded = (0, _ramda.isNil)(amount) ? fallbackValue : roundNumber(amount * 100, decimals);
    var roundedWithSign = rounded === '0.00' && amount < 0 ? '0.00' : rounded;
    return roundedWithSign === fallbackValue ? fallbackValue : NumberUtility.convertToEuropeanFormat(roundedWithSign, false) + '%';
  },
  convertDecimalToMultiply100WithFixedDecimals: function convertDecimalToMultiply100WithFixedDecimals(amount, decimalPlaces) {
    var rounded = (0, _ramda.isNil)(amount) ? '-' : roundNumber(amount * 100, decimalPlaces);
    var roundedWithSign = rounded === '0.00' && amount < 0 ? '0.00' : rounded;
    return roundedWithSign === '-' ? '-' : NumberUtility.convertToEuropeanFormat(roundedWithSign, false);
  },
  convertToAmount: function convertToAmount(amount) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';

    if (decimalPlaces < 0) return amount;

    var rounded = (0, _ramda.isNil)(amount) || isNaN(amount) ? fallbackValue : roundNumber(amount, decimalPlaces);

    var roundedWithSign = rounded === '0.00' && amount < 0 ? '0.00' : rounded;
    return roundedWithSign === fallbackValue ? fallbackValue : NumberUtility.convertToEuropeanFormat(roundedWithSign, false);
  },
  convertToAmountWithPreciseRounding: function convertToAmountWithPreciseRounding(amount) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';
    var convertFromPercentage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var thousandSeparator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var convertToPercent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (decimalPlaces === -1 && !(0, _ramda.isNil)(amount)) {
      return amount;
    }
    var rounded = fallbackValue;
    if ((0, _ramda.isNil)(amount)) {
      rounded = fallbackValue;
    } else {
      rounded = Number(amount);
      rounded = preciseRounding(convertFromPercentage ? rounded * 100 : rounded, decimalPlaces, fallbackValue);

      if (thousandSeparator) {
        rounded = convertToNumberWithCommas(rounded);
      }

      rounded = NumberUtility.convertToEuropeanFormat(rounded, false);

      if (convertToPercent) {
        rounded = rounded + '%';
      }
    }

    return rounded === fallbackValue ? fallbackValue : rounded;
  },
  formatToPercentWith1FixedDecimals: function formatToPercentWith1FixedDecimals(amount) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

    var rounded = (0, _ramda.isNil)(amount) ? fallbackValue : roundNumber(amount, 1);
    var roundedWithSign = rounded === '0.0' && amount < 0 ? '0.0' : rounded;
    return roundedWithSign === fallbackValue ? fallbackValue : NumberUtility.convertToEuropeanFormat(roundedWithSign, false) + '%';
  },
  formatToPercentWith2FixedDecimals: function formatToPercentWith2FixedDecimals(amount) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

    var rounded = (0, _ramda.isNil)(amount) ? fallbackValue : roundNumber(amount, 2);
    var roundedWithSign = rounded === '0.00' && amount < 0 ? '0.00' : rounded;
    return roundedWithSign === fallbackValue ? fallbackValue : NumberUtility.convertToEuropeanFormat(roundedWithSign, false) + '%';
  },
  formatToPercentWith2FixedDecimalsAfterMultiplyingBy100: function formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(amount) {
    if ((0, _ramda.isNil)(amount) || isNaN(amount)) {
      return '-';
    } else {
      var rounded = roundNumber(amount * 100, 2);
      return NumberUtility.convertToEuropeanFormat(rounded, false) + '%';
    }
  },
  formatToPercentWithSuppliedDecimalPointCount: function formatToPercentWithSuppliedDecimalPointCount(amount, numberOfDecimalPoint) {
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';

    if ((0, _ramda.isNil)(amount) || isNaN(amount)) {
      return fallbackValue;
    } else {
      return Number(amount).toFixed(numberOfDecimalPoint) + '%';
    }
  },
  formatToPercentWithoutDecimalPoints: function formatToPercentWithoutDecimalPoints(amount) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

    if ((0, _ramda.isNil)(amount) || isNaN(amount)) {
      return fallbackValue;
    } else {
      return Number(amount) + '%';
    }
  },
  convertToNDecimalFixedNumber: function convertToNDecimalFixedNumber(number, decimalPlaces, enableNull) {
    var fallbackValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';

    var isNullSign = enableNull ? null : fallbackValue;
    return (0, _ramda.isNil)(number) ? isNullSign : NumberUtility.convertToEuropeanFormat(number.toFixed(decimalPlaces), false);
  },
  convertToTwoDecimalFixedNumberWithNoRounding: function convertToTwoDecimalFixedNumberWithNoRounding(number) {
    return (0, _ramda.isNil)(number) ? '-' : parseFloat(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]).toFixed(2);
  },
  convertToNumberWithCommas: function convertToNumberWithCommas(number) {

    var language = (0, _functional_utility.pathOrNull)(['fundsMarketingConfiguration', 'language'], window);
    if ("ca" === (0, _functional_utility.pathOrNull)(['fundsMarketingConfiguration', 'country'], window)) {
      return NumberUtility.convertToCanadianFormat(number, language);
    }

    if (number && typeof number.toString === "function") {
      var s1 = number.toString();
      if (s1.indexOf('.') >= 0) {
        var parts = s1.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
      } else {
        return s1.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  },
  formatAmountWithCurrencySignAndCommasForLocale: function formatAmountWithCurrencySignAndCommasForLocale(amount, decimalPlaces) {
    return amount.toLocaleString('en-US', {
      style: 'currency', currency: 'USD', maximumFractionDigits: decimalPlaces,
      minimumFractionDigits: decimalPlaces
    });
  },
  getPlaceValue: function getPlaceValue(amount) {
    var log = Math.floor(this.log10(amount));
    var placeValue = Math.pow(10, log);
    return placeValue;
  },
  log10: function log10(number) {
    return Math.log(number) * Math.LOG10E;
  },
  getRoundedUpAmountBasedOnPlaceValue: function getRoundedUpAmountBasedOnPlaceValue(amount) {
    var placeValue = this.getPlaceValue(amount);
    return Math.ceil(amount / placeValue) * placeValue;
  },
  getRoundedUpAmount: function getRoundedUpAmount(amount, stepSize) {
    if (!(0, _ramda.isNil)(stepSize) && stepSize > 0) {
      return Math.ceil(amount / stepSize) * stepSize;
    }
    if (amount <= 50) {
      return Math.ceil(amount / 50) * 50;
    }
    if (amount <= 500) {
      return Math.ceil(amount / 100) * 100;
    }
    if (amount <= 1000) {
      return Math.ceil(amount / 500) * 500;
    }
    return this.getRoundedUpAmountBasedOnPlaceValue(amount);
  },
  getTicks: function getTicks(startAmount, maxAmount, initialAmount, maxTicks, stepSize) {
    var ticksForYAxis = [];
    var range = maxAmount - startAmount;
    var amountForEachTick = range / maxTicks;
    var roundedAmountForEachTick = this.getRoundedUpAmount(amountForEachTick, stepSize);

    ticksForYAxis.push(initialAmount);
    var runningAmount = initialAmount;
    if (startAmount < initialAmount) {
      while (startAmount < runningAmount) {
        runningAmount -= roundedAmountForEachTick;
        ticksForYAxis.push(runningAmount);
      }
    }
    runningAmount = initialAmount;
    while (runningAmount < maxAmount) {
      runningAmount += roundedAmountForEachTick;
      ticksForYAxis.push(runningAmount);
    }
    ticksForYAxis.sort(function (a, b) {
      return a - b;
    });
    return ticksForYAxis;
  },
  getPercentageTicks: function getPercentageTicks(startPercentage, maxPercentage, initialPercentage, maxTicks) {
    var ticksForYAxis = [];
    var range = maxPercentage - startPercentage;
    var amountForEachTick = range / maxTicks;

    ticksForYAxis.push(initialPercentage.toFixed(2));
    var runningAmount = initialPercentage;
    if (startPercentage < initialPercentage) {
      while (startPercentage < runningAmount) {
        runningAmount -= amountForEachTick;
        ticksForYAxis.push(runningAmount.toFixed(2));
      }
    }
    runningAmount = initialPercentage;
    while (runningAmount < maxPercentage) {
      runningAmount += amountForEachTick;
      ticksForYAxis.push(runningAmount.toFixed(2));
    }
    ticksForYAxis.sort(function (a, b) {
      return a - b;
    });
    return ticksForYAxis;
  },
  renderValueOrEmDash: function renderValueOrEmDash(value) {
    return (0, _ramda.isNil)(value) ? "—" : convertDecimalToMultiply100WithFixedDecimals(value, 2);
  },
  renderPreciseValueOrEmDash: function renderPreciseValueOrEmDash(value) {
    return (0, _ramda.isNil)(value) ? "—" : convertToAmountWithPreciseRounding(value, 2, '-', true, false, false);
  },
  getDynamicMobileWidth: function getDynamicMobileWidth(percentOfScreen) {
    return window.document.documentElement.clientWidth * percentOfScreen;
  },
  getDecimalPointCount: function getDecimalPointCount(number) {
    if (isNaN(number)) {
      return 0;
    }
    if (!(0, _ramda.isNil)(number) && number.toString().indexOf('.') > -1) {
      return number.toString().split('.')[1].length || 0;
    }
    return 0;
  },
  convertToCanadianFormat: function convertToCanadianFormat(value, language) {
    if (typeof value !== "string" && typeof value !== "number") {
      return value;
    }

    if (typeof value === 'number') {
      value = value.toString();
    }

    if (value.includes("e")) {
      value = Number(value).toFixed(12).replace(/\.?0+$/, "");
    }

    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(language === 'fr' ? ',' : '.');
  },
  convertToEuropeanFormat: function convertToEuropeanFormat(value) {
    var europeanFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // TODO: it should check only the format that comes from backend
    // currently it's scattered in too many places, so just checking the country for CA
    var country = (0, _functional_utility.pathOrNull)(['fundsMarketingConfiguration', 'country'], window);
    var language = (0, _functional_utility.pathOrNull)(['fundsMarketingConfiguration', 'language'], window);
    if (europeanFormat === "canadian" || country === "ca") {
      return NumberUtility.convertToCanadianFormat(value, language);
    }

    if (typeof value !== "string" || !europeanFormat) {
      return value;
    }

    return (0, _ramda.map)(function (char) {
      if (char === ".") {
        return ",";
      } else if (char === ",") {
        return ".";
      }

      return char;
    }, value).join("");
  },
  getMaxAndMinAmount: function getMaxAndMinAmount(propertyNames, objectList) {
    var additionalMin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var additionalMax = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    if ((0, _functional_utility.isNilOrEmpty)(propertyNames) || (0, _functional_utility.isNilOrEmpty)(objectList)) {
      return {};
    }
    return objectList.reduce(function (prev, curr) {
      var allValues = propertyNames.map(function (propName) {
        return curr[propName];
      }).filter(function (val) {
        return Number.isFinite(val);
      });
      return {
        minAmount: Math.min.apply(Math, [].concat(_toConsumableArray(allValues), _toConsumableArray(additionalMin), [prev.minAmount])),
        maxAmount: Math.max.apply(Math, [].concat(_toConsumableArray(allValues), _toConsumableArray(additionalMax), [prev.maxAmount]))
      };
    }, { minAmount: Number.MAX_VALUE, maxAmount: Number.NEGATIVE_INFINITY });
  },
  preciseRounding: function preciseRounding(num, dec, fallbackValue) {
    if (typeof num !== 'number' || typeof dec !== 'number') {
      return fallbackValue;
    }
    var numSign = num >= 0 ? 1 : -1;
    return (Math.round(num * Math.pow(10, dec) + numSign * 0.00000001) / Math.pow(10, dec)).toFixed(dec);
  },
  roundNumber: function roundNumber(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
  },
  isNilOrHyphen: function isNilOrHyphen(value) {
    return (0, _ramda.isNil)(value) || value === "-";
  }
};

exports.default = NumberUtility;
var convertDecimalToPercentWith2FixedDecimals = NumberUtility.convertDecimalToPercentWith2FixedDecimals,
    convertDecimalToMultiply100WithFixedDecimals = NumberUtility.convertDecimalToMultiply100WithFixedDecimals,
    convertToAmount = NumberUtility.convertToAmount,
    convertToAmountWithPreciseRounding = NumberUtility.convertToAmountWithPreciseRounding,
    formatToPercentWith1FixedDecimals = NumberUtility.formatToPercentWith1FixedDecimals,
    formatToPercentWith2FixedDecimals = NumberUtility.formatToPercentWith2FixedDecimals,
    formatToPercentWith2FixedDecimalsAfterMultiplyingBy100 = NumberUtility.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100,
    convertToNDecimalFixedNumber = NumberUtility.convertToNDecimalFixedNumber,
    convertToTwoDecimalFixedNumberWithNoRounding = NumberUtility.convertToTwoDecimalFixedNumberWithNoRounding,
    convertToNumberWithCommas = NumberUtility.convertToNumberWithCommas,
    formatAmountWithCurrencySignAndCommasForLocale = NumberUtility.formatAmountWithCurrencySignAndCommasForLocale,
    getPlaceValue = NumberUtility.getPlaceValue,
    log10 = NumberUtility.log10,
    getRoundedUpAmountBasedOnPlaceValue = NumberUtility.getRoundedUpAmountBasedOnPlaceValue,
    getRoundedUpAmount = NumberUtility.getRoundedUpAmount,
    getTicks = NumberUtility.getTicks,
    getPercentageTicks = NumberUtility.getPercentageTicks,
    renderValueOrEmDash = NumberUtility.renderValueOrEmDash,
    renderPreciseValueOrEmDash = NumberUtility.renderPreciseValueOrEmDash,
    getDynamicMobileWidth = NumberUtility.getDynamicMobileWidth,
    convertToEuropeanFormat = NumberUtility.convertToEuropeanFormat,
    formatToPercentWithSuppliedDecimalPointCount = NumberUtility.formatToPercentWithSuppliedDecimalPointCount,
    formatToPercentWithoutDecimalPoints = NumberUtility.formatToPercentWithoutDecimalPoints,
    getDecimalPointCount = NumberUtility.getDecimalPointCount,
    preciseRounding = NumberUtility.preciseRounding,
    roundNumber = NumberUtility.roundNumber,
    isNilOrHyphen = NumberUtility.isNilOrHyphen;
exports.convertDecimalToPercentWith2FixedDecimals = convertDecimalToPercentWith2FixedDecimals;
exports.convertDecimalToMultiply100WithFixedDecimals = convertDecimalToMultiply100WithFixedDecimals;
exports.convertToAmount = convertToAmount;
exports.convertToAmountWithPreciseRounding = convertToAmountWithPreciseRounding;
exports.formatToPercentWith1FixedDecimals = formatToPercentWith1FixedDecimals;
exports.formatToPercentWith2FixedDecimals = formatToPercentWith2FixedDecimals;
exports.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100 = formatToPercentWith2FixedDecimalsAfterMultiplyingBy100;
exports.convertToNDecimalFixedNumber = convertToNDecimalFixedNumber;
exports.convertToTwoDecimalFixedNumberWithNoRounding = convertToTwoDecimalFixedNumberWithNoRounding;
exports.convertToNumberWithCommas = convertToNumberWithCommas;
exports.formatAmountWithCurrencySignAndCommasForLocale = formatAmountWithCurrencySignAndCommasForLocale;
exports.getPlaceValue = getPlaceValue;
exports.log10 = log10;
exports.getRoundedUpAmountBasedOnPlaceValue = getRoundedUpAmountBasedOnPlaceValue;
exports.getRoundedUpAmount = getRoundedUpAmount;
exports.getTicks = getTicks;
exports.getPercentageTicks = getPercentageTicks;
exports.renderValueOrEmDash = renderValueOrEmDash;
exports.renderPreciseValueOrEmDash = renderPreciseValueOrEmDash;
exports.getDynamicMobileWidth = getDynamicMobileWidth;
exports.convertToEuropeanFormat = convertToEuropeanFormat;
exports.formatToPercentWithSuppliedDecimalPointCount = formatToPercentWithSuppliedDecimalPointCount;
exports.formatToPercentWithoutDecimalPoints = formatToPercentWithoutDecimalPoints;
exports.getDecimalPointCount = getDecimalPointCount;
exports.preciseRounding = preciseRounding;
exports.roundNumber = roundNumber;
exports.isNilOrHyphen = isNilOrHyphen;